export default "__VITE_ASSET__BvBC9dph__"